import React from 'react';
import { useIntl } from 'react-intl';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { SMLPreview } from '../smlPreview/SMLPreview';
import { SMLPreviewMessageData } from '../smartLinkDetailsView/messageListeners/types';
import { editorMessages } from './editorMessages';
import { EditorStatus, editorStatusLabel } from './topBar/editorStatus';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './SMLEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLEditorPhonePreviewProps {
  smartLink: SerializedSmartLink;
  status: EditorStatus;
  onEdit: () => void;
  onPreviewMessage: (data: SMLPreviewMessageData) => void;
}

/** Phone width: the draft page full screen (`?view=preview`) with "Edit" to go back (design a8). */
const SMLEditorPhonePreviewComponent: React.FC<SMLEditorPhonePreviewProps> = ({
  smartLink,
  status,
  onEdit,
  onPreviewMessage,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.phonePreview} data-testid="editor-phone-preview">
      <div className={styles.phonePreviewBar}>
        <SMLButton outline leftIcon={faPen} onClick={onEdit} omitCap>
          {intl.formatMessage(editorMessages.backToEditor)}
        </SMLButton>
        <span className={styles.phonePreviewStatus}>{editorStatusLabel(intl, status)}</span>
      </div>
      <div className={styles.phonePreviewFrame}>
        <SMLPreview
          smartLink={smartLink}
          type="column"
          onPreviewMessageEvent={onPreviewMessage}
          showOpenPreviewBar={false}
        />
      </div>
    </div>
  );
};

export const SMLEditorPhonePreview = TypedMemo(SMLEditorPhonePreviewComponent);
